import * as Styled from "./AttendanceTab.styles";
import {
  Box,
  CircularProgress,
  IconButton,
  Skeleton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { useAppDispatch } from "../../../../store/hooks";
import { refreshLiveEventAttendees } from "../../../../store/actions/liveEventActions";

import { Attendee } from "../../../../types/attendee";
import { Contact } from "../../../../components";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddAttendeeButton from "../../../../components/AddAttendeeButton/AddAttendeeButton";
import AddAttendeeModal from "../../../../modals/AddAttendeeModal/AddAttendeeModal";

const AttendanceTab = () => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const user = useSelector((state: RootState) => state.user);
  const eventAttendees = useSelector((state: RootState) => state.liveEvent.attendees);
  const event = useSelector((state: RootState) => state.liveEvent.data);
  const [showAddAttendeeModal, setShowAddAttendeeModal] = useState(false);

  const isCurrentUserOrganizer = event?.eventOrganizerEmail === user.email;


  return (
    <Styled.PaddedContainer>
      {eventAttendees.loading ? (
        <>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ marginBottom: theme.spacing(3) }}
          >
            <Box display="flex" alignItems="center">
              <Styled.AttendanceText variant="h3">Attendance</Styled.AttendanceText>
              <Styled.AttendanceCountContainer>
                <Styled.AttendanceIcon />
                <Skeleton variant="text" sx={{ width: "24px" }} />
              </Styled.AttendanceCountContainer>
            </Box>
            <AddAttendeeButton onClick={() => setShowAddAttendeeModal(true)} />
          </Stack>

          {Array(12).fill(
            <Styled.ContactSkeletonContainer>
              <Styled.ContactAvatarSkeleton variant="circular" />
              <Skeleton variant="text" sx={{ width: "400px", height: "36px" }} />
            </Styled.ContactSkeletonContainer>
          )}
        </>
      ) : (
        <>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ marginBottom: theme.spacing(3) }}
          >
            <Box display="flex" alignItems="center">
              <Box marginRight="8px">
                {eventAttendees.refreshing ? (
                  <Box margin="8px">
                    <CircularProgress size={"24px"} />
                  </Box>
                ) : (
                  <IconButton
                    onClick={() => {
                      if (event) {
                        dispatch(refreshLiveEventAttendees(event.eventId));
                      }
                    }}
                  >
                    <RefreshIcon />
                  </IconButton>
                )}
              </Box>
              <Typography variant="h3">Attendance</Typography>
              <Styled.AttendanceCountContainer>
                <Styled.AttendanceIcon />
                <Typography variant="body1">
                  {eventAttendees.data.length}
                </Typography>
              </Styled.AttendanceCountContainer>
            </Box>
            {isCurrentUserOrganizer &&
            <AddAttendeeButton onClick={() => setShowAddAttendeeModal(true)} />
            }
          </Stack>

          {eventAttendees.data.map((attendee: Attendee) => (
            <Box
              key={attendee.participantEmail}
              sx={{
                px: 2,
                py: 1,
                maxWidth: "100%",
                overflow: "hidden",
              }}
            >
              <Contact size={36} name={attendee.participantName} />
            </Box>
          ))}
        </>
      )}

      <AddAttendeeModal
        open={showAddAttendeeModal}
        onClose={() => setShowAddAttendeeModal(false)}
      />
    </Styled.PaddedContainer>
  );
};

export default AttendanceTab;
